import React, { useState } from "react";
import { useAuth } from "@/lib/auth";

/**
 * Email/password sign-in form for the gate overlay. Owns its own local
 * state (email, password, error, loading) and calls into the auth context
 * on submit. Strings are intentionally English-only.
 */
export default function LoginForm() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Invalid credentials.";
      setError(typeof detail === "string" ? detail : "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid="login-form">
      {error && (
        <p
          data-testid="login-error"
          className="mt-7 text-center text-sm"
          style={{ color: "#E08687" }}
        >
          {error}
        </p>
      )}

      <div className="mt-8 space-y-6">
        <label className="block">
          <span className="eyebrow text-ivory/55" style={{ fontSize: 10 }}>
            Email
          </span>
          <input
            data-testid="login-email"
            type="email"
            required
            autoFocus
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-0 border-b border-ivory/30 focus:border-brass focus:outline-none text-ivory mt-2 pb-2"
            style={{ fontFamily: "Inter, sans-serif", fontSize: "1rem" }}
          />
        </label>
        <label className="block">
          <span className="eyebrow text-ivory/55" style={{ fontSize: 10 }}>
            Password
          </span>
          <input
            data-testid="login-password"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-0 border-b border-ivory/30 focus:border-brass focus:outline-none text-ivory mt-2 pb-2"
            style={{ fontFamily: "Inter, sans-serif", fontSize: "1rem" }}
          />
        </label>
      </div>

      <button
        type="submit"
        disabled={loading}
        data-testid="login-submit"
        className="mt-10 w-full text-ivory disabled:opacity-50 transition-colors"
        style={{
          backgroundColor: "#151E2B",
          border: "1px solid #151E2B",
          padding: "0.95rem 1.65rem",
          fontFamily: '"Bebas Neue", "Inter", sans-serif',
          fontSize: 13,
          letterSpacing: "0.24em",
          textTransform: "uppercase",
        }}
      >
        {loading ? "Entering…" : "Enter"}
      </button>
    </form>
  );
}
